import { format, parseISO } from "date-fns";

export const PAY_STATUS = ["Unpaid", "Paid", "Free", "Waived"];

const t12 = (t) => format(parseISO(`2000-01-01T${t}`), "h:mm a");

export const scheduleWhen = (s) => {
  let w = format(parseISO(s.date), "EEE, MMM d, yyyy");
  if (s.end_date && s.end_date !== s.date) w += ` – ${format(parseISO(s.end_date), "MMM d, yyyy")}`;
  if (s.start_time) w += ` · ${t12(s.start_time)}${s.end_time ? ` – ${t12(s.end_time)}` : ""}`;
  return w;
};

export const feeLabel = (fee) => (fee ? `PHP ${Number(fee).toLocaleString("en-PH", { minimumFractionDigits: 2 })}` : "Free");

export const journeyKey = () => {
  let k = localStorage.getItem("vp_journey_key");
  if (!k) { k = crypto.randomUUID(); localStorage.setItem("vp_journey_key", k); }
  return k;
};

export const readContact = () => JSON.parse(localStorage.getItem("vp_journey_contact") || "null");
export const saveContact = (c) => localStorage.setItem("vp_journey_contact", JSON.stringify(c));
